import { Card, CardHeader, Stack, Typography } from "@mui/material";
import { MetricsCollectionFilterButton, MetricsGrid } from "src/components";
import { useGetTeam } from "src/http";
import { useTeamMeetingSettings } from "../hooks";

interface IProps {
  teamSlug: string;
}

const TeamMetricsAgendaStep = (props: IProps) => {
  const { settings, updateMetricSettings } = useTeamMeetingSettings(props.teamSlug);
  const { data: team, isLoading: isLoadingTeam } = useGetTeam(props.teamSlug);

  if (!isLoadingTeam && team) {
    return (
      <Stack spacing={1}>
        <Card>
          <CardHeader
            title={
              <Stack spacing={0.75}>
                <Typography variant="h5">Metrics</Typography>
                <MetricsCollectionFilterButton
                  variant="text"
                  metricCollectionGuid={team.metricCollectionGuid}
                  filters={settings.metrics.filters}
                  onFiltersChanged={(filters) => updateMetricSettings({ filters })}
                />
              </Stack>
            }
          />
        </Card>

        <MetricsGrid
          metricCollectionGuid={team.metricCollectionGuid}
          filters={settings.metrics.filters}
          userCanRemove={(metric) => (team.isMember || team.isAdministrator) && metric.assignedTeam.slug !== team.slug}
        />
      </Stack>
    );
  }

  return null;
};

export { TeamMetricsAgendaStep };
